import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Toggle from "../../components/Toggle";

const NoPaymentLinks = () => {
  return (
    <div className="overflow-x-hidden">
      <div className="flex flex-col xl:flex-row items-start justify-between">
        <h1 className="text-navy-blue text-2xl font-bold">Payments</h1>

        <div className="flex sm:flex-row flex-col justify-center items-center">
          <Toggle />
        </div>
      </div>
      <div className="bg-white min-h-screen md:max-w-full max-w-72 mt-8 px-5 overflow-hidden">
        <h1 className="font-bold lg:text-[50px] text-xl md:text-3xl lg:w-[715px] pt-4">
          <span className="block leading-[75px]">
            Whether you are a freelancer or a creator, this is the best way to
            receive money from your clients.
          </span>
        </h1>
        <Link to="/payments/payment-links/create-link">
          <button className="text-white px-3 md:px-0 bg-primary md:w-[272px] h-[42px] text-base font-normal rounded-[10px] mt-4 flex items-center justify-center gap-2">
            <span>
              <svg
                width="15"
                height="16"
                viewBox="0 0 15 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_28_11865)">
                  <path
                    d="M11.25 8.625H8.125V11.75C8.125 12.0938 7.84375 12.375 7.5 12.375C7.15625 12.375 6.875 12.0938 6.875 11.75V8.625H3.75C3.40625 8.625 3.125 8.34375 3.125 8C3.125 7.65625 3.40625 7.375 3.75 7.375H6.875V4.25C6.875 3.90625 7.15625 3.625 7.5 3.625C7.84375 3.625 8.125 3.90625 8.125 4.25V7.375H11.25C11.5938 7.375 11.875 7.65625 11.875 8C11.875 8.34375 11.5938 8.625 11.25 8.625Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_28_11865">
                    <rect
                      width="15"
                      height="15"
                      fill="white"
                      transform="translate(0 0.5)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </span>
            Create a payment link
          </button>
        </Link>
      </div>
    </div>
  );
};

export default NoPaymentLinks;
